module.exports = __webpack_public_path__ + "static/media/JS.08802079.svg";